/**
 * PageToolbar — barre d'outils sous le header de page.
 *
 * Slots ordonnes : viewToggle | search | period | actions | (refresh).
 * Sous le top, les `children` rendent une seconde rangee de filtres.
 *
 *   <PageToolbar
 *     search={<SearchInput .../>}
 *     actions={<Button>Filtrer</Button>}
 *     onRefresh={refetch}
 *   >
 *     <FilterBar .../>
 *   </PageToolbar>
 *
 * Adapte de scapino-portal/frontend/src/components/ui/PageToolbar.tsx.
 */

import { RefreshCw } from 'lucide-react'
import type { ReactNode } from 'react'

import Button from '@/components/ui/Button'

import './PageToolbar.css'

interface PageToolbarProps {
  viewToggle?: ReactNode
  search?: ReactNode
  period?: ReactNode
  actions?: ReactNode
  onRefresh?: () => void
  refreshDisabled?: boolean
  refreshLabel?: string
  children?: ReactNode
  className?: string
}

export default function PageToolbar({
  viewToggle,
  search,
  period,
  actions,
  onRefresh,
  refreshDisabled,
  refreshLabel = 'Rafraîchir',
  children,
  className,
}: PageToolbarProps) {
  return (
    <div className={`page-toolbar${className ? ` ${className}` : ''}`}>
      <div className="page-toolbar-top">
        {viewToggle}
        {search}
        {period}
        {actions}
        {onRefresh && (
          <Button
            variant="ghost"
            size="sm"
            onClick={onRefresh}
            disabled={refreshDisabled}
            aria-label={refreshLabel}
            title={refreshLabel}
          >
            <RefreshCw size={14} aria-hidden="true" />
          </Button>
        )}
      </div>
      {children && <div className="page-toolbar-filters">{children}</div>}
    </div>
  )
}
